import { Config } from "./types";

const config: Config = {
    API_URL: "https://staging-api.fitforwork.ai/api/v2",
    BUGSNAG_KEY: "bf5b0d515b60142658aed82461fb95c7",
    AUTH_0: {
        AUTH_CLIENT_ID: 'W5WbbOQbkHKAP4JriuvmRgOpiglh0osX',
        AUTH_DOMAIN: 'facecheck-staging.eu.auth0.com',
        AUTH_AUDIENCE: 'staging.fitforwork.ai',
        REDIRECT_URL: 'https://portal-staging.fitforwork.ai/users',
    },
};

export default config;
